import React from 'react';

export default function ProgressBar({ current, total }) {
    const percent = total > 0 ? Math.round((current / total) * 100) : 0;

    return (
        <div className="oc-progress-wrapper">
            <div className="oc-progress-track">
                <div
                    className="oc-progress-fill"
                    style={{ width: `${percent}%` }}
                />
            </div>
            <span className="oc-progress-label">Step {current} of {total}</span>
        </div>
    );
}
